/**
 * Resolve a notification deep-link for navigation.
 *
 * Only in-app relative paths are accepted. Empty strings, bare "/", hashes,
 * and absolute URLs are treated as "no route" so the open-link icon stays hidden.
 *
 * @param {unknown} relativeUrl Value from ``notification.relative_url``.
 * @return {string|null} Path to navigate to, or null when there is no route.
 */
export function getNotificationRoute(relativeUrl) {
  if (typeof relativeUrl !== "string") {
    return null;
  }
  const path = relativeUrl.trim();
  if (!path || path === "/") {
    return null;
  }
  if (!path.startsWith("/")) {
    return null;
  }
  // Reject protocol-relative and absolute URLs (//host or /http...).
  if (path.startsWith("//") || /^\/[a-z][a-z0-9+.-]*:/i.test(path)) {
    return null;
  }
  return path;
}
